import { listVal, nbVal, strValOrUndef } from "@paroi/data-formatters-lib";
import { type TableData, formatToTableData } from "./table-data.formatter";

export interface Statistics {
  kpis: KpiStat[];
  diagramData?: Map<string, number>;
  latestData: {
    data: TableData[];
    page: number;
    perPage: number;
    total: number;
  };
}

export interface KpiStat {
  tableId: number;
  name?: string;
  property?: string;
  value?: string;
  data: {
    count: number;
    updatedAt?: string;
  };
}

export function formatToStatistics(data: any): Statistics {
  let diagramData: Map<string, number> | undefined;
  if (data.histogram_data && typeof data.histogram_data === "object") {
    for (const [key, val] of Object.entries(data.histogram_data)) {
      if (!diagramData) diagramData = new Map();
      diagramData.set(key, nbVal(val));
    }
  }
  return {
    kpis: listVal(data.kpis, formatToKpiStat),
    diagramData,
    latestData: {
      data: listVal(data.latest_data?.data ?? [], formatToTableData),
      page: nbVal(data.latest_data?.current_page ?? 1),
      perPage: nbVal(data.latest_data?.per_page ?? 0),
      total: nbVal(data.latest_data?.total ?? 0),
    },
  };
}

function formatToKpiStat(data: any): KpiStat {
  return {
    tableId: nbVal(data.table_id),
    name: strValOrUndef(data.name),
    property: strValOrUndef(data.porperty),
    value: strValOrUndef(data.value),
    data: {
      count: nbVal(data.data.count),
      updatedAt: strValOrUndef(data.data.updated_at),
    },
  };
}
